import styled from 'styled-components';
import zIndex from 'styles/zIndex';

import TopNav from 'containers/TopNav';

/**
 * v3 改版后的布局样式：
 * - TopNav 自带 fixed 定位与 .v3-scope（其内部渲染玻璃导航），不再需要 sticky 包裹层。
 * - Footer 自带深色样式与内边距，不再需要包装层。
 */

export const Layout = styled.div`
  position: relative;
`;

export const LayoutContent = styled.div`
  min-height: calc(100vh - 348px);
`;

export const LayoutTopNav = styled(TopNav)`
  z-index: ${zIndex.layout};
`;
